import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import MenuCard from "@/components/MenuCard";
import { Skeleton } from "@/components/ui/skeleton";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export default function Menus() {
  const [menus, setMenus] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cat, setCat] = useState("All");

  useEffect(() => {
    (async () => {
      setLoading(true);
      const r = await api.get("/menus");
      setMenus(r.data.menus);
      setLoading(false);
    })();
  }, []);

  const cats = ["All", ...Array.from(new Set(menus.map(m => m.category)))];
  const filtered = cat === "All" ? menus : menus.filter(m => m.category === cat);

  return (
    <div className="max-w-7xl mx-auto px-6 py-16">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
        <div>
          <div className="small-caps text-neutral-500 mb-3">Curated by our editors</div>
          <h1 className="font-serif-display text-5xl md:text-6xl leading-none">Mini catering menus.</h1>
          <p className="text-neutral-400 mt-4 max-w-xl">
            Open menus, curated by leading chefs. Describe the evening — we compose it.
          </p>
        </div>
        <Select value={cat} onValueChange={setCat}>
          <SelectTrigger data-testid="menu-cat-filter" className="rounded-none h-11 md:w-56 bg-transparent border-white/10">
            <SelectValue />
          </SelectTrigger>
          <SelectContent className="rounded-none bg-[#141414] border-white/10">
            {cats.map((c) => <SelectItem key={c} value={c} className="rounded-none">{c}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>

      <div className="dotted-sep my-10" />

      <div className="grid gap-6 stagger-in" data-testid="menus-grid">
        {loading ? Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="card-lux flex flex-col md:flex-row">
            <Skeleton className="md:w-2/5 aspect-[4/3] rounded-none bg-neutral-900" />
            <div className="md:w-3/5 p-6"><Skeleton className="h-8 w-1/2 bg-neutral-800" /></div>
          </div>
        )) : filtered.map((m) => <MenuCard key={m.id} menu={m} />)}
      </div>
    </div>
  );
}
